import type { ComponentType } from 'react'
import { resolveForMimeType } from '@common/plugin-host'
import mediaTextManifest from '@common/plugin-media-text/manifest'
import PayloadEditor from '../asset/PayloadEditor'

export type AssetEditorProps = { value?: string; onChange?: (value: string) => void; editable?: boolean }

const assetEditors: { mimeTypes: readonly string[]; component: ComponentType<AssetEditorProps> }[] = [
  { mimeTypes: mediaTextManifest.mimeTypes ?? [], component: PayloadEditor },
]

export const resolveAssetEditor = (mimeType: string | undefined): ComponentType<AssetEditorProps> | undefined =>
  mimeType ? resolveForMimeType(assetEditors, mimeType)[0]?.component : undefined
